import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccessBatch = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 156,
	height: 113,
	viewBox: "0 0 156 113",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M32.0844 -0.000976562C27.1504 -0.000976562 23.0837 4.08492 23.0837 9.04228V90.4316C23.0837 95.389 27.1504 99.4749 32.0844 99.4749H146.093C151.027 99.4749 155.094 95.389 155.094 90.4316V9.04228C155.094 4.08492 151.027 -0.000976562 146.093 -0.000976562H32.0844ZM31.8558 5.8507H59.4007C59.5056 5.88636 59.6162 5.92202 59.7269 5.94578C61.5563 6.23105 63.071 7.18192 64.6672 8.84587C66.2635 10.5098 67.8365 12.8277 69.5609 15.3118C70.8775 17.2076 72.3165 19.2222 74.0351 21.0645H28.8737V8.89334C28.8737 7.1521 30.1495 5.85054 31.8565 5.85054L31.8558 5.8507ZM70.5611 5.85054H146.304C148.021 5.85054 149.304 7.15205 149.304 8.89334V21.0645H87.0132C86.8257 21.0288 86.6382 21.017 86.4507 21.017C81.4355 20.4643 78.4827 16.6251 75.108 11.7935C73.7194 9.80853 72.2078 7.77017 70.5616 5.85062L70.5611 5.85054ZM36.4006 10.5318C34.8004 10.5318 33.5056 11.8404 33.5056 13.4575C33.5056 15.0747 34.8004 16.3833 36.4006 16.3833C38.0007 16.3833 39.2955 15.0747 39.2955 13.4575C39.2955 11.8404 38.0007 10.5318 36.4006 10.5318ZM46.8224 10.5318C45.2222 10.5318 43.9275 11.8404 43.9275 13.4575C43.9275 15.0747 45.2223 16.3833 46.8224 16.3833C48.4226 16.3833 49.7174 15.0747 49.7174 13.4575C49.7174 11.8404 48.4226 10.5318 46.8224 10.5318ZM57.2443 10.5318C55.6441 10.5318 54.3493 11.8404 54.3493 13.4575C54.3493 15.0747 55.6442 16.3833 57.2443 16.3833C58.8444 16.3833 60.1393 15.0747 60.1393 13.4575C60.1393 11.8404 58.8444 10.5318 57.2443 10.5318ZM28.8737 26.916H148.146V90.5912C148.146 92.3264 146.871 93.6234 145.164 93.6234H31.8555C30.1491 93.6234 28.8737 92.3264 28.8737 90.5912V26.916Z",
			fill: "#E2E3E3"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 32.5885,
			cy: 82.3735,
			rx: 31.6825,
			ry: 30.6264,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M81.5068 60.8462C81.5068 60.3856 81.8807 60.0117 82.3413 60.0117L96.1115 60.0117C96.5722 60.0117 96.946 60.3856 96.946 60.8462C96.946 61.3069 96.5722 61.6808 96.1115 61.6808L82.3413 61.6808C81.8807 61.6808 81.5068 61.3069 81.5068 60.8462Z",
			fill: "#B2B5B2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 73.665,
			y: 54.2549,
			width: 31.1222,
			height: 13.1798,
			rx: 6,
			stroke: "#B2B5B2",
			strokeWidth: 4,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M98.9624 79.2203C98.9624 78.7596 99.3363 78.3857 99.7969 78.3857L113.567 78.3857C114.028 78.3857 114.402 78.7596 114.402 79.2203C114.402 79.6809 114.028 80.0548 113.567 80.0548L99.7969 80.0548C99.3363 80.0548 98.9624 79.6809 98.9624 79.2203Z",
			fill: "#B2B5B2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 91.1206,
			y: 72.6289,
			width: 31.1222,
			height: 13.1798,
			rx: 6,
			stroke: "#B2B5B2",
			strokeWidth: 4,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M65.8884 41.5523C65.8884 41.0916 66.2623 40.7178 66.7229 40.7178L80.4931 40.7178C80.9538 40.7178 81.3276 41.0916 81.3276 41.5523C81.3276 42.013 80.9538 42.3868 80.4931 42.3868L66.7229 42.3868C66.2623 42.3868 65.8884 42.013 65.8884 41.5523Z",
			fill: "#B2B5B2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 58.0466,
			y: 34.9609,
			width: 31.1222,
			height: 13.1798,
			rx: 6,
			stroke: "#B2B5B2",
			strokeWidth: 4,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.3045 66.8489C61.2484 66.4265 60.1923 66.9545 59.7699 68.0106L57.2353 74.8751C53.6446 64.4199 43.6118 57.0273 32.3117 57.0273C21.1173 57.133 11.0845 64.2087 7.38818 74.7695C6.96575 75.8256 7.5994 77.0929 8.65548 77.5153C9.71156 77.9378 10.9789 77.3041 11.4013 76.248C14.5695 67.377 22.9126 61.4629 32.3117 61.4629C41.8165 61.4629 50.1595 67.5882 53.2222 76.248L47.0969 74.0303C46.0408 73.6078 44.9847 74.1359 44.5623 75.192C44.3511 75.72 44.4567 76.248 44.6679 76.6705C44.8791 77.0929 45.3015 77.5153 45.724 77.7266L56.8128 81.8453C57.3409 82.0565 57.8689 81.9509 58.2914 81.7397C58.7138 81.5285 59.1362 81.106 59.3474 80.6836L63.4662 69.3835C63.783 68.3274 63.2549 67.2713 62.3045 66.8489Z",
			fill: "#008C73"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.3906 87.5483C55.2289 87.2315 54.0672 87.9707 53.856 89.0268C51.3214 98.8484 42.4503 105.607 32.4175 105.607C22.2791 105.607 13.3024 98.5316 10.8734 88.8156L17.4211 91.2446C18.4772 91.667 19.5333 91.139 19.9557 90.0829C20.1669 89.5549 20.0613 89.0268 19.8501 88.6044C19.6389 88.182 19.2165 87.7595 18.794 87.5483L7.70515 83.4296C7.17711 83.2184 6.64907 83.324 6.22664 83.5352C5.80421 83.7464 5.38177 84.1688 5.17056 84.5913L1.05183 95.6801C0.629401 96.7362 1.15744 97.7923 2.21353 98.2147C3.26961 98.6372 4.32569 98.1091 4.74812 97.053L7.07151 90.8222C10.3454 101.911 20.695 109.937 32.4175 109.937C44.4568 109.937 55.0177 101.805 57.9747 90.1885C58.1859 89.0268 57.4466 87.8651 56.3906 87.5483Z",
			fill: "#008C73"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.6519 83.5357C23.6519 88.2881 27.4538 92.09 32.2061 92.09C36.9585 92.09 40.7604 88.2881 40.7604 83.5357C40.7604 78.7833 36.9585 74.9814 32.2061 74.9814C27.4538 74.9814 23.6519 78.7833 23.6519 83.5357ZM27.8763 83.4305C27.8763 81.1072 29.7772 79.1006 32.2062 79.1006C34.5296 79.1006 36.5361 81.1072 36.5361 83.4305C36.5361 85.7539 34.6352 87.7605 32.2062 87.7605C29.8828 87.7605 27.8763 85.8595 27.8763 83.4305Z",
			fill: "#008C73"
		})
	]
});
const ForwardRef = forwardRef(SvgSuccessBatch);
export { ForwardRef as ReactComponent };
